import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCheckCircle2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCheckCircle2"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M7.5 13.2692L10.5 16.5L15.5 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCheckCircle2;
